/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_In_Reason_Return_From_Scenting_HintInputs */

const vi_sl_in_reason_return_from_scenting_hint = /** @type {(inputs: Sl_In_Reason_Return_From_Scenting_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn kg thừa từ kho lấy hương về lô phân loại`)
};

/**

* @param {Sl_In_Reason_Return_From_Scenting_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_in_reason_return_from_scenting_hint = /** @type {((inputs?: Sl_In_Reason_Return_From_Scenting_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_In_Reason_Return_From_Scenting_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_in_reason_return_from_scenting_hint(inputs)
});